const Alerts = {
  baseStyle: {
    container: {
      p: 4,
      borderRadius: "lg",
    },
  },
  variants: {
    standard: {
      container: {
        mt: 2,
        mb: 2,
        p: 2,
        borderRadius: "lg",
        bg: "Alert",
        color: "black",
        justifyContent: "center",
        alignItems: "center",
      },
    },
  },
}

export default Alerts
